
import React, { useState, useEffect } from 'react';
import './Typewriter.css';

const getPlainText = (children) => {
  if (typeof children === 'string') {
    return children;
  }
  if (Array.isArray(children)) {
    return children.map(getPlainText).join('');
  }
  if (React.isValidElement(children) && children.props.children) {
    return getPlainText(children.props.children);
  }
  return '';
};

const Typewriter = ({ children, speed = 50, showCursor = false, replay = false, cursorClass = '' }) => {
  const [fullText] = useState(getPlainText(children));
  const [typedText, setTypedText] = useState('');
  const [isComplete, setIsComplete] = useState(false);
  const [animationKey, setAnimationKey] = useState(0); // New state for forcing re-animation

  // Effect to trigger re-animation when replay prop changes
  useEffect(() => {
    if (replay) {
      setAnimationKey(prevKey => prevKey + 1); // Increment key to force re-run of typing effect
      setTypedText(''); // Reset typed text
      setIsComplete(false); // Reset completion status
    }
  }, [replay]);

  // Original typing effect, now dependent on animationKey
  useEffect(() => {
    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < fullText.length) {
        setTypedText(fullText.substring(0, i + 1));
        i++;
      } else {
        clearInterval(typingInterval);
        setIsComplete(true);
      }
    }, speed);

    return () => clearInterval(typingInterval);
  }, [fullText, speed, animationKey]);

  if (isComplete) {
    return (
      <>
        {children}
        {showCursor && <span className={`cursor ${cursorClass}`}></span>}
      </>
    );
  }

  return (
    <span className="typing-text">
      {typedText}
      {showCursor && <span className={`cursor ${cursorClass}`}></span>}
    </span>
  );
};

export default Typewriter;
